import React, { useEffect, useLayoutEffect, useRef, useState } from "react"
import { graphql, useStaticQuery } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

/* eslint-disable */

const TIME_AUTO_MOVE_SLIDE = 9000

const HighlyRecommended = ({ params }) => {
  const [shortCodeRegion, regionName] = params.location.split("/")

  const slideInterval = useRef(null)
  const testimonials = useTestimonialData()

  const [testimonialsRender, setTestimonialsRender] = useState([
    ...testimonials,
  ])

  const timerRef = useRef(null)

  useEffect(() => {
    timerRef.current = () => {
      const newTestimonialsRender = [...testimonialsRender]
      newTestimonialsRender.map(band => (band.class = ""))
      setTestimonialsRender(newTestimonialsRender)
    }
    return () => {
      clearInterval(slideInterval.current)
    }
  }, [testimonialsRender])

  useLayoutEffect(() => {
    slideInterval.current = setInterval(
      async () => await nextSlide(),
      TIME_AUTO_MOVE_SLIDE
    )
  }, [])

  const timeOut = time => {
    return new Promise(resolve => setTimeout(resolve, time))
  }

  const nextSlide = async () => {
    const testimonialsEl = document.querySelectorAll(".testimonial-main")
    const activeEl = document.querySelector(".active-testimonial")
    const indexActive = parseInt(activeEl.getAttribute("data-set"))
    activeEl.style.animation = "right-to-left--out .3s"
    await timeOut(200)
    activeEl.classList.replace("active-testimonial", "in-active-testimonial")
    const indexPrev =
      indexActive - 1 < 0 ? testimonialsRender.length - 1 : indexActive - 1
    testimonialsEl[indexPrev].style.animation = "right-to-left--in .3s"
    testimonialsEl[indexPrev].classList.replace(
      "in-active-testimonial",
      "active-testimonial"
    )
  }

  const prevSlide = async () => {
    const testimonialsEl = document.querySelectorAll(".testimonial-main")
    const activeEl = document.querySelector(".active-testimonial")
    const indexActive = parseInt(activeEl.getAttribute("data-set"))
    activeEl.style.animation = "left-to-right--out .3s"
    await timeOut(200)
    activeEl.classList.replace("active-testimonial", "in-active-testimonial")
    const indexNext =
      indexActive + 1 > testimonialsRender.length - 1 ? 0 : indexActive + 1
    testimonialsEl[indexNext].style.animation = "left-to-right--in .3s"
    testimonialsEl[indexNext].classList.replace(
      "in-active-testimonial",
      "active-testimonial"
    )
  }
  const reRenderTestimonials = async action => {
    clearInterval(slideInterval.current)
    if (action === "next") nextSlide()
    else prevSlide()
    slideInterval.current = setInterval(
      async () => await nextSlide(),
      TIME_AUTO_MOVE_SLIDE
    )
  }

  return (
    <div className="max-w-screen-2xl mx-auto py-20 px-10">
      <div className="text-right mt-10 hidden lg:block">
        <button onClick={() => reRenderTestimonials("prev")}>
          <StaticImage
            className="mr-5"
            src="../../static/images/icon/angle-arrow-left.svg"
            alt="arrow"
          />
        </button>
        <button onClick={() => reRenderTestimonials("next")}>
          <StaticImage
            src="../../static/images/icon/angle-arrow-right.svg"
            alt="arrow"
          />
        </button>
      </div>
      <div className="flex flex-col lg:flex-row items-center justify-between 2xl:px-0 min-h-[500px]">
        <div className="sm:w-2/3 lg:w-1/2">
          <div className="mx-auto lg:w-full">
            <p className="font-cardo--46 lg:font-cardo--53 leading-none">
              We come highly
              <br />
              recommended
            </p>
            <p className="font-bold font-syne--20 lg:font-syne--22 my-10 uppercase leading-8 lg:w-3/5">
              Hire a {regionName} wedding band who gets rave reviews from
              brides-and-grooms-to-be.
            </p>
          </div>
        </div>
        <div className="sm:w-2/3 lg:mb-0 lg:w-1/2">
          <div className="lg:hidden text-right mt-10">
            <button onClick={() => reRenderTestimonials("prev")}>
              <StaticImage
                className="mr-5"
                src="../../static/images/icon/angle-arrow-left.svg"
                alt="arrow"
              />
            </button>
            <button onClick={() => reRenderTestimonials("next")}>
              <StaticImage
                src="../../static/images/icon/angle-arrow-right.svg"
                alt="arrow"
              />
            </button>
          </div>
          <div className="max-w-2xl flex overflow-hidden relative">
            {testimonialsRender?.map((item, index) => {
              return (
                <div
                  className={`duration-700 testimonial-main ${
                    index !== 0 ? `in-active-testimonial` : `active-testimonial`
                  }`}
                  data-set={`${index}`}
                  key={`testimonial ${index}`}
                >
                  <p className="font-cardo leading-tight">
                    “<br />
                    {item.content || ""}
                  </p>
                  <p className="font-montserrat--18 font-bold mt-10">
                    {item.author || ""}
                  </p>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </div>
  )
}

const useTestimonialData = () => {
  const { allTestimonialJson } = useStaticQuery(
    graphql`
      query TestimonialData {
        allTestimonialJson {
          nodes {
            content
            author
          }
        }
      }
    `
  )
  return allTestimonialJson.nodes
}

export default HighlyRecommended
